<i class="fa fa-long-arrow-left inicio ml-1" aria-hidden="true"><a routerLink='/inicio' class="text-left inicio">
    Inicio</a></i>

<div class="container mt-5 mb-5">

    <!--Logo-->
    <div class="d-flex justify-content-center mb-4">
        <img
          style="width: 10%"
          class="d-flex justify-content-center"
          src="https://i.imgur.com/5KOEUob.png"
          alt="Logo repassa"
        />
      </div>
      <!--Logo-->

    <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
            <h1 class="text-center" id="atualizar">Atualizar postagem</h1>
        </div>
    </div>

    <div class="row d-flex justify-content-center">
        <div class="col-md-6">
            <div class="form-group">
                <label for="texto">Escolha um tema ou <a data-dismiss="modal" routerLink='/tema'>cadastre um novo</a></label>
                <select class="form-control" [(ngModel)]='idTema' (change)='findByIdTema()' name="tema" id="tema">
                    <option *ngFor='let item of listaTemas 'value="{{item.id}}">{{item.descricao}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="titulo">Título:</label>
                <input [(ngModel)]='postagem.titulo' type="text" class="form-control" id="titulo">
            </div>
            <div class="form-group">
                <label for="texto">Texto:</label>
                <input [(ngModel)]='postagem.texto' type="text" class="form-control" id="texto">
            </div>
            <div class="form-group">
                <label for="imagem">Imagem:</label>
                <input [(ngModel)]='postagem.img' type="text" class="form-control" id="imagem">
            </div>
            <div class="d-flex justify-content-center">
                <button class="btn btn-danger mr-4" id="botao-cancelar" routerLink='/inicio'>Cancelar</button>
                <button (click)='atualizar()'class="btn" id="botao-atualizar">Atualizar</button>

            </div>
        </div>
    </div>
</div>
